import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import HeaderContainer from 'components/common/Header/HeaderContainer'
import SimpleSnackbar from 'components/common/SnackBar'
import LoadingView from './LoadingView'
import appActions from './actions'
import PropTypes from 'prop-types'
import useStyles from './Styles'

const GuestLayout = ({ children, showHeader = true }) => {
    const { busy, toast } = useSelector((state) => state.app)

    const { message, type } = toast
    const classes = useStyles()
    const { removeToastMessage } = appActions()

    return (
        <>
            {showHeader && <HeaderContainer />}
            <div className={classes.mainContent}>{children}</div>
            {message && (
                <SimpleSnackbar
                    clearMessage={removeToastMessage}
                    message={message}
                    type={type}
                />
            )}
        </>
    )
}

GuestLayout.propTypes = {
    showHeader: PropTypes.bool,
}

GuestLayout.defaultProps = {
    showHeader: true,
}

export default GuestLayout
